import React from 'react';
import { settings } from '../../config/settings';
import ControlService from '../../helper/controlservice';
const uuidv4 = require('uuid/v4');

function EmailNotification(action, control, datamodel, token) {
    let body;
    let users;
    let fromname;
    let fromemail;
    let emailconnection;
    let attachments;
    let attachmentsvar;
    let emailsubject;
    if (action == "create") {
        if (control.createemailnotification) {
            body = control.createemailtemplate;
            emailsubject = control.createemailsubject;
            let keys = Object.keys(datamodel);
            keys.forEach(Option => {
                body = body.replace("{{" + Option + "}}", datamodel[Option]);
                emailsubject = emailsubject.replace("{{" + Option + "}}", datamodel[Option]);
            });
            users = [];
            if (control.createtoemails && control.createtoemails.length > 0) {
                let Receivers = [];
                control.createtoemails.forEach(emailOption => {
                    if (emailOption.indexOf("{{") > -1) {
                        keys.forEach(Option => {
                            emailOption = emailOption.replace("{{" + Option + "}}", datamodel[Option]);

                        });


                    }
                    Receivers.push(emailOption);

                });
                users = Receivers;
            }
            if (control.sendemailtologgedinuser) {
                users.push(token.user.email);
            }
            fromname = control.createfromname;
            fromemail = control.createfromemail;

            emailconnection = control.createemailconnection;
            attachments = control.createemailattachments ? control.createemailattachments : [];
            attachmentsvar = control.createattachmentvar ? control.createattachmentvar : [];
        }
    } else if (action == "update") {
        if (control.updateemailnotification) {
            body = control.updateemailtemplate;

            fromname = control.updatefromname;
            fromemail = control.updatefromemail;
            emailsubject = control.updateemailsubject;
            let keys = Object.keys(datamodel);
            keys.forEach(Option => {
                body = body.replace("{{" + Option + "}}", datamodel[Option]);
                emailsubject = emailsubject.replace("{{" + Option + "}}", datamodel[Option]);
            });
            users = [];
            if (control.updatetoemails && control.updatetoemails.length > 0) {
                let Receivers = [];
                control.updatetoemails.forEach(emailOption => {
                    if (emailOption.indexOf("{{") > -1) {
                        keys.forEach(Option => {
                            emailOption = emailOption.replace("{{" + Option + "}}", datamodel[Option]);
                        });


                    }
                    Receivers.push(emailOption);

                });
                users = Receivers;
            }
            if (control.sendemailtologgedinuser) {
                users.push(token.user.email);
            }
            emailconnection = control.updateemailconnection;
            attachments = control.updateemailattachments ? control.updateemailattachments : [];
            attachmentsvar = control.updateattachmentvar ? control.updateattachmentvar : [];
        }
    }
    attachmentsvar.forEach(Option => {
        attachments.push(datamodel[Option]);
    });
    // emailconnection = { "provider": control.provider, "accesskey": control.accesskey };

    return {
        fromname,
        fromemail,
        emailsubject,
        users,
        body,
        emailconnection,
        attachments
    };
}
function AppNotification(action, control, datamodel, token, isWebNotification, isMobileNotification) {
    let header = "";
    let description = "";
    let userIds = [];
    let appnotificationcomment = control.appnotificationcomment ? control.appnotificationcomment : '';
    if (action === 'create') {
        header = control.appnotificationheader;
        description = control.appnotificationdescription;
    } else {
        header = control.appnotificationheaderupdate;
        description = control.appnotificationdescriptionupdate;
    }
    description = description ? description : '';
    //control.appnotificationparameters
    let apiParam = {};
    Array.isArray(control.appnotificationparameters) && control.appnotificationparameters.forEach(option => {
        apiParam[option.key] = option.value;
    });
    ControlService().setPageVariablesFromMenu(control.appnotificationparameters, apiParam, token, datamodel);
    Array.isArray(control.appnotificationparameters) && control.appnotificationparameters.forEach(option => {
        header = header.replace("{{" + option.key + "}}", apiParam[option.value] ? apiParam[option.value] : '');
        description = description.replace("{{" + option.key + "}}", apiParam[option.value] ? apiParam[option.value] : '');
        appnotificationcomment = appnotificationcomment.replace("{{" + option.key + "}}", apiParam[option.value] ? apiParam[option.value] : '');
    });
    if (control.appnotificationtype !== 'broadcast') {
        Array.isArray(control.appnotificationuserid) && control.appnotificationuserid.forEach(userid => {
            userIds.push(userid);
        });
        Array.isArray(control.appnotificationdynamicuserid) && control.appnotificationdynamicuserid.forEach(userid => {
            if (datamodel[userid]) {
                userIds.push(datamodel[userid]);
            }
        });
    }
    return (
        {
            "header": header,
            "description": description,
            "redirecturl": null,
            "status": null,
            "notificationFor": isWebNotification && isMobileNotification ? 'both' : isWebNotification ? 'web' : isMobileNotification ? 'mobile' : 'web',
            "notificationType": control.appnotificationtype,
            "comment": appnotificationcomment,
            "userId": userIds,
            "isRead": false,
            "partitionKey": "Notification",
            "rowKey": uuidv4(),
            "createdOn": new Date(),
            "createdBy": token.user ? token.user.email : 'NA'
        }
    );
}
export const sendnotificationQue = (action, control, datamodel, token) => {
    var emailnotification = false;
    var webnotification = false;
    var mobilenotification = false;
    var quickbook = false;

    var emaildata = {};
    var webdata = {};
    var mobiledata = {};
    var quickbookdata = {};

    const isWebNotification = token && token.menu && token.menu.webnotification;
    const isMobileNotification = token && token.menu && token.menu.mobilenotification;

    if (control.createemailnotification || control.updateemailnotification) {
        emailnotification = true;
        emaildata = EmailNotification(action, control, datamodel, token);
    }
    if (isMobileNotification && control.appnotification && (control.appnotificationfor == 'both' || control.appnotificationfor == 'mobile')) {
        mobilenotification = true;
    }
    if (isWebNotification && control.appnotification && (control.appnotificationfor == 'both' || control.appnotificationfor == 'web')) {
        webnotification = true;
    }
    webdata = AppNotification(action, control, datamodel, token, webnotification, mobilenotification);
    mobiledata = AppNotification(action, control, datamodel, token, webnotification, mobilenotification);

    if (control.quickbook) {
        quickbook = true;
        quickbookdata = EmailNotification(action, control, datamodel, token);
    }
    var model = {
        emailnotification: emailnotification,
        emaildata: emaildata,
        mobilenotification: mobilenotification,
        mobiledata: mobiledata,
        webnotification: webnotification,
        webdata: webdata,
        quickbook: quickbook,
        quickbookdata: quickbookdata
    };
    const _control = {
        method: settings.METHOD.POST,
        datasource: 'http'
    }
    _ = ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.NOTIFICATION_QUE_API, {}, _control, token, model);
}
export const RefreshComponentOnClose = (control, formid, props) => {
    if (control.sidebarcloseonsubmit && (props.isModelOpened || props.isSidebarOpened)) {
        if (props.isModelOpened) {
            props.resetModelPopup(!props.isModelOpened);
        } else if (props.isSidebarOpened) {
            props.setPageParams(null);
            props.resetSidebar(!props.isSidebarOpened);
            props.setSidebarFormId(null);
            props.resetData(null, props.sidebarFormId + "write_validation");
        }
    }
    if (control.refreshcomponentonclose && control.refreshcomponenformid) {
        props.update(control.refreshcomponentonclose + '_refresh', uuidv4(), control.refreshcomponenformid + 'write');
    } else if (control.refreshcomponentonclose) {
        if (control.refreshcomponentonclose.toLowerCase().trim() == 'reload')
            window.location.reload();
        else
            props.setreload({ activeformid: formid, formid: control.refreshcomponentonclose.trim().toLowerCase(), refresh: true });
    } else if (control.refreshcomponenformid) {
        props.setreload({ activeformid: formid, formid: control.refreshcomponenformid, refresh: true });
    }
}
export const extractErrorMessage = (InValidControls) => {
    let _InValidControls = InValidControls.map((items, index) => {
        if (index < 10) {
            return (
                <li>{items.control.label ? items.control.label : items.control.placeholder} : This field is required,</li>
            )
        }
    })
    return (
        <>
            <p><em>Whoops!</em>- There is a problem with the form, please check and correct the following:</p>
            <ul>
                {_InValidControls}
            </ul>
        </>
    )
}
export const printPDF = async (control, token, model, formid, regenerate = 'no') => {
    const _control = {
        method: 'post',
        datasource: 'http'
    }
    let apiParam = {
        templateFile: control.pdftemplateurl,
        fileName: control.key + '_' + model[control.PrimaryKey] + '.pdf',
        fileGenerate: regenerate
    }
    return await ControlService().ServiceRequest(ControlService().azureFunctionUrl(token) + settings.PRINT_PDF_API, apiParam, _control, token, model)
        .then(res => { return res });
}